<template>
<div>
  <v-simple-table dark>
    <thead>
    <tr>
        <th align='left'>Hex</th>
        <th align='left'>Colour</th>
    </tr>
    </thead>
    <tbody>
    <tr>
        <td>
            <font @click="sendFont('#F0F8FF')" style="cursor:pointer" color='#F0F8FF'><b>&nbsp;F0F8FF&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#F0F8FF')" style="cursor:pointer" color='#F0F8FF'><b>&nbsp; AliceBlue&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FAEBD7')" style="cursor:pointer" color='#FAEBD7'><b>&nbsp;FAEBD7&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FAEBD7')" style="cursor:pointer" color='#FAEBD7'><b>&nbsp; AntiqueWhite&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#00FFFF')" style="cursor:pointer" color='#00FFFF'><b>&nbsp;00FFFF&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#00FFFF')" style="cursor:pointer" color='#00FFFF'><b>&nbsp; Aqua&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#7FFFD4')" style="cursor:pointer" color='#7FFFD4'><b>&nbsp;7FFFD4&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#7FFFD4')" style="cursor:pointer" color='#7FFFD4'><b>&nbsp; Aquamarine&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#F0FFFF')" style="cursor:pointer" color='#F0FFFF'><b>&nbsp;F0FFFF&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#F0FFFF')" style="cursor:pointer" color='#F0FFFF'><b>&nbsp; Azure&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#F5F5DC')" style="cursor:pointer" color='#F5F5DC'><b>&nbsp;F5F5DC&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#F5F5DC')" style="cursor:pointer" color='#F5F5DC'><b>&nbsp; Beige&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FFE4C4')" style="cursor:pointer" color='#FFE4C4'><b>&nbsp;FFE4C4&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FFE4C4')" style="cursor:pointer" color='#FFE4C4'><b>&nbsp; Bisque&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#000000')" style="cursor:pointer" color='#FFFFFF'><b>&nbsp;000000&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#000000')" style="cursor:pointer" color='#FFFFFF'><b>&nbsp; Black&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FFEBCD')" style="cursor:pointer" color='#FFEBCD'><b>&nbsp;FFEBCD&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FFEBCD')" style="cursor:pointer" color='#FFEBCD'><b>&nbsp; BlanchedAlmond&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#0000FF')" style="cursor:pointer" color='#0000FF'><b>&nbsp;0000FF&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#0000FF')" style="cursor:pointer" color='#0000FF'><b>&nbsp; Blue&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#8A2BE2')" style="cursor:pointer" color='#8A2BE2'><b>&nbsp;8A2BE2&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#8A2BE2')" style="cursor:pointer" color='#8A2BE2'><b>&nbsp; BlueViolet&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#A52A2A')" style="cursor:pointer" color='#A52A2A'><b>&nbsp;A52A2A&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#A52A2A')" style="cursor:pointer" color='#A52A2A'><b>&nbsp; Brown&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#DEB887')" style="cursor:pointer" color='#DEB887'><b>&nbsp;DEB887&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#DEB887')" style="cursor:pointer" color='#DEB887'><b>&nbsp; BurlyWood&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#5F9EA0')" style="cursor:pointer" color='#5F9EA0'><b>&nbsp;5F9EA0&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#5F9EA0')" style="cursor:pointer" color='#5F9EA0'><b>&nbsp; CadetBlue&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#7FFF00')" style="cursor:pointer" color='#7FFF00'><b>&nbsp;7FFF00&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#7FFF00')" style="cursor:pointer" color='#7FFF00'><b>&nbsp; Chartreuse&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#D2691E')" style="cursor:pointer" color='#D2691E'><b>&nbsp;D2691E&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#D2691E')" style="cursor:pointer" color='#D2691E'><b>&nbsp; Chocolate&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FF7F50')" style="cursor:pointer" color='#FF7F50'><b>&nbsp;FF7F50&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FF7F50')" style="cursor:pointer" color='#FF7F50'><b>&nbsp; Coral&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#6495ED')" style="cursor:pointer" color='#6495ED'><b>&nbsp;6495ED&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#6495ED')" style="cursor:pointer" color='#6495ED'><b>&nbsp; CornflowerBlue&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FFF8DC')" style="cursor:pointer" color='#FFF8DC'><b>&nbsp;FFF8DC&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FFF8DC')" style="cursor:pointer" color='#FFF8DC'><b>&nbsp; Cornsilk&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#DC143C')" style="cursor:pointer" color='#DC143C'><b>&nbsp;DC143C&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#DC143C')" style="cursor:pointer" color='#DC143C'><b>&nbsp; Crimson&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#00FFFF')" style="cursor:pointer" color='#00FFFF'><b>&nbsp;00FFFF&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#00FFFF')" style="cursor:pointer" color='#00FFFF'><b>&nbsp; Cyan&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#00008B')" style="cursor:pointer" color='#00008B'><b>&nbsp;00008B&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#00008B')" style="cursor:pointer" color='#00008B'><b>&nbsp; DarkBlue&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#008B8B')" style="cursor:pointer" color='#008B8B'><b>&nbsp;008B8B&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#008B8B')" style="cursor:pointer" color='#008B8B'><b>&nbsp; DarkCyan&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#B8860B')" style="cursor:pointer" color='#B8860B'><b>&nbsp;B8860B&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#B8860B')" style="cursor:pointer" color='#B8860B'><b>&nbsp; DarkGoldenRod&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#A9A9A9')" style="cursor:pointer" color='#A9A9A9'><b>&nbsp;A9A9A9&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#A9A9A9')" style="cursor:pointer" color='#A9A9A9'><b>&nbsp; DarkGray&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#006400')" style="cursor:pointer" color='#006400'><b>&nbsp;006400&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#006400')" style="cursor:pointer" color='#006400'><b>&nbsp; DarkGreen&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#BDB76B')" style="cursor:pointer" color='#BDB76B'><b>&nbsp;BDB76B&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#BDB76B')" style="cursor:pointer" color='#BDB76B'><b>&nbsp; DarkKhaki&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#8B008B')" style="cursor:pointer" color='#8B008B'><b>&nbsp;8B008B&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#8B008B')" style="cursor:pointer" color='#8B008B'><b>&nbsp; DarkMagenta&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#556B2F')" style="cursor:pointer" color='#556B2F'><b>&nbsp;556B2F&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#556B2F')" style="cursor:pointer" color='#556B2F'><b>&nbsp; DarkOliveGreen&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FF8C00')" style="cursor:pointer" color='#FF8C00'><b>&nbsp;FF8C00&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FF8C00')" style="cursor:pointer" color='#FF8C00'><b>&nbsp; Darkorange&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#9932CC')" style="cursor:pointer" color='#9932CC'><b>&nbsp;9932CC&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#9932CC')" style="cursor:pointer" color='#9932CC'><b>&nbsp; DarkOrchid&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#8B0000')" style="cursor:pointer" color='#8B0000'><b>&nbsp;8B0000&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#8B0000')" style="cursor:pointer" color='#8B0000'><b>&nbsp; DarkRed&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#E9967A')" style="cursor:pointer" color='#E9967A'><b>&nbsp;E9967A&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#E9967A')" style="cursor:pointer" color='#E9967A'><b>&nbsp; DarkSalmon&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#8FBC8F')" style="cursor:pointer" color='#8FBC8F'><b>&nbsp;8FBC8F&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#8FBC8F')" style="cursor:pointer" color='#8FBC8F'><b>&nbsp; DarkSeaGreen&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#483D8B')" style="cursor:pointer" color='#483D8B'><b>&nbsp;483D8B&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#483D8B')" style="cursor:pointer" color='#483D8B'><b>&nbsp; DarkSlateBlue&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#2F4F4F')" style="cursor:pointer" color='#2F4F4F'><b>&nbsp;2F4F4F&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#2F4F4F')" style="cursor:pointer" color='#2F4F4F'><b>&nbsp; DarkSlateGray&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#00CED1')" style="cursor:pointer" color='#00CED1'><b>&nbsp;00CED1&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#00CED1')" style="cursor:pointer" color='#00CED1'><b>&nbsp; DarkTurquoise&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#9400D3')" style="cursor:pointer" color='#9400D3'><b>&nbsp;9400D3&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#9400D3')" style="cursor:pointer" color='#9400D3'><b>&nbsp; DarkViolet&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FF1493')" style="cursor:pointer" color='#FF1493'><b>&nbsp;FF1493&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FF1493')" style="cursor:pointer" color='#FF1493'><b>&nbsp; DeepPink&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#00BFFF')" style="cursor:pointer" color='#00BFFF'><b>&nbsp;00BFFF&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#00BFFF')" style="cursor:pointer" color='#00BFFF'><b>&nbsp; DeepSkyBlue&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#696969')" style="cursor:pointer" color='#696969'><b>&nbsp;696969&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#696969')" style="cursor:pointer" color='#696969'><b>&nbsp; DimGray&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#1E90FF')" style="cursor:pointer" color='#1E90FF'><b>&nbsp;1E90FF&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#1E90FF')" style="cursor:pointer" color='#1E90FF'><b>&nbsp; DodgerBlue&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#B22222')" style="cursor:pointer" color='#B22222'><b>&nbsp;B22222&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#B22222')" style="cursor:pointer" color='#B22222'><b>&nbsp; FireBrick&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FFFAF0')" style="cursor:pointer" color='#FFFAF0'><b>&nbsp;FFFAF0&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FFFAF0')" style="cursor:pointer" color='#FFFAF0'><b>&nbsp; FloralWhite&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#228B22')" style="cursor:pointer" color='#228B22'><b>&nbsp;228B22&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#228B22')" style="cursor:pointer" color='#228B22'><b>&nbsp; ForestGreen&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FF00FF')" style="cursor:pointer" color='#FF00FF'><b>&nbsp;FF00FF&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FF00FF')" style="cursor:pointer" color='#FF00FF'><b>&nbsp; Fuchsia&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#DCDCDC')" style="cursor:pointer" color='#DCDCDC'><b>&nbsp;DCDCDC&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#DCDCDC')" style="cursor:pointer" color='#DCDCDC'><b>&nbsp; Gainsboro&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#F8F8FF')" style="cursor:pointer" color='#F8F8FF'><b>&nbsp;F8F8FF&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#F8F8FF')" style="cursor:pointer" color='#F8F8FF'><b>&nbsp; GhostWhite&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FFD700')" style="cursor:pointer" color='#FFD700'><b>&nbsp;FFD700&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FFD700')" style="cursor:pointer" color='#FFD700'><b>&nbsp; Gold&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#DAA520')" style="cursor:pointer" color='#DAA520'><b>&nbsp;DAA520&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#DAA520')" style="cursor:pointer" color='#DAA520'><b>&nbsp; GoldenRod&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#808080')" style="cursor:pointer" color='#808080'><b>&nbsp;808080&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#808080')" style="cursor:pointer" color='#808080'><b>&nbsp; Gray&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#008000')" style="cursor:pointer" color='#008000'><b>&nbsp;008000&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#008000')" style="cursor:pointer" color='#008000'><b>&nbsp; Green&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#ADFF2F')" style="cursor:pointer" color='#ADFF2F'><b>&nbsp;ADFF2F&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#ADFF2F')" style="cursor:pointer" color='#ADFF2F'><b>&nbsp; GreenYellow&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#F0FFF0')" style="cursor:pointer" color='#F0FFF0'><b>&nbsp;F0FFF0&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#F0FFF0')" style="cursor:pointer" color='#F0FFF0'><b>&nbsp; HoneyDew&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FF69B4')" style="cursor:pointer" color='#FF69B4'><b>&nbsp;FF69B4&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FF69B4')" style="cursor:pointer" color='#FF69B4'><b>&nbsp; HotPink&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#CD5C5C')" style="cursor:pointer" color='#CD5C5C'><b>&nbsp;CD5C5C&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#CD5C5C')" style="cursor:pointer" color='#CD5C5C'><b>&nbsp; IndianRed &nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#4B0082')" style="cursor:pointer" color='#4B0082'><b>&nbsp;4B0082&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#4B0082')" style="cursor:pointer" color='#4B0082'><b>&nbsp; Indigo &nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FFFFF0')" style="cursor:pointer" color='#FFFFF0'><b>&nbsp;FFFFF0&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FFFFF0')" style="cursor:pointer" color='#FFFFF0'><b>&nbsp; Ivory&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#F0E68C')" style="cursor:pointer" color='#F0E68C'><b>&nbsp;F0E68C&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#F0E68C')" style="cursor:pointer" color='#F0E68C'><b>&nbsp; Khaki&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#E6E6FA')" style="cursor:pointer" color='#E6E6FA'><b>&nbsp;E6E6FA&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#E6E6FA')" style="cursor:pointer" color='#E6E6FA'><b>&nbsp; Lavender&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FFF0F5')" style="cursor:pointer" color='#FFF0F5'><b>&nbsp;FFF0F5&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FFF0F5')" style="cursor:pointer" color='#FFF0F5'><b>&nbsp; LavenderBlush&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#7CFC00')" style="cursor:pointer" color='#7CFC00'><b>&nbsp;7CFC00&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#7CFC00')" style="cursor:pointer" color='#7CFC00'><b>&nbsp; LawnGreen&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FFFACD')" style="cursor:pointer" color='#FFFACD'><b>&nbsp;FFFACD&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FFFACD')" style="cursor:pointer" color='#FFFACD'><b>&nbsp; LemonChiffon&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#ADD8E6')" style="cursor:pointer" color='#ADD8E6'><b>&nbsp;ADD8E6&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#ADD8E6')" style="cursor:pointer" color='#ADD8E6'><b>&nbsp; LightBlue&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#F08080')" style="cursor:pointer" color='#F08080'><b>&nbsp;F08080&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#F08080')" style="cursor:pointer" color='#F08080'><b>&nbsp; LightCoral&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#E0FFFF')" style="cursor:pointer" color='#E0FFFF'><b>&nbsp;E0FFFF&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#E0FFFF')" style="cursor:pointer" color='#E0FFFF'><b>&nbsp; LightCyan&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FAFAD2')" style="cursor:pointer" color='#FAFAD2'><b>&nbsp;FAFAD2&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FAFAD2')" style="cursor:pointer" color='#FAFAD2'><b>&nbsp; LightGoldenRodYellow&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#D3D3D3')" style="cursor:pointer" color='#D3D3D3'><b>&nbsp;D3D3D3&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#D3D3D3')" style="cursor:pointer" color='#D3D3D3'><b>&nbsp; LightGrey&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#90EE90')" style="cursor:pointer" color='#90EE90'><b>&nbsp;90EE90&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#90EE90')" style="cursor:pointer" color='#90EE90'><b>&nbsp; LightGreen&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FFB6C1')" style="cursor:pointer" color='#FFB6C1'><b>&nbsp;FFB6C1&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FFB6C1')" style="cursor:pointer" color='#FFB6C1'><b>&nbsp; LightPink&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FFA07A')" style="cursor:pointer" color='#FFA07A'><b>&nbsp;FFA07A&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FFA07A')" style="cursor:pointer" color='#FFA07A'><b>&nbsp; LightSalmon&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#20B2AA')" style="cursor:pointer" color='#20B2AA'><b>&nbsp;20B2AA&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#20B2AA')" style="cursor:pointer" color='#20B2AA'><b>&nbsp; LightSeaGreen&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#87CEFA')" style="cursor:pointer" color='#87CEFA'><b>&nbsp;87CEFA&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#87CEFA')" style="cursor:pointer" color='#87CEFA'><b>&nbsp; LightSkyBlue&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#778899')" style="cursor:pointer" color='#778899'><b>&nbsp;778899&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#778899')" style="cursor:pointer" color='#778899'><b>&nbsp; LightSlateGray&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#B0C4DE')" style="cursor:pointer" color='#B0C4DE'><b>&nbsp;B0C4DE&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#B0C4DE')" style="cursor:pointer" color='#B0C4DE'><b>&nbsp; LightSteelBlue&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FFFFE0')" style="cursor:pointer" color='#FFFFE0'><b>&nbsp;FFFFE0&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FFFFE0')" style="cursor:pointer" color='#FFFFE0'><b>&nbsp; LightYellow&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#00FF00')" style="cursor:pointer" color='#00FF00'><b>&nbsp;00FF00&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#00FF00')" style="cursor:pointer" color='#00FF00'><b>&nbsp; Lime&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#32CD32')" style="cursor:pointer" color='#32CD32'><b>&nbsp;32CD32&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#32CD32')" style="cursor:pointer" color='#32CD32'><b>&nbsp; LimeGreen&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FAF0E6')" style="cursor:pointer" color='#FAF0E6'><b>&nbsp;FAF0E6&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FAF0E6')" style="cursor:pointer" color='#FAF0E6'><b>&nbsp; Linen&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FF00FF')" style="cursor:pointer" color='#FF00FF'><b>&nbsp;FF00FF&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FF00FF')" style="cursor:pointer" color='#FF00FF'><b>&nbsp; Magenta&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#800000')" style="cursor:pointer" color='#800000'><b>&nbsp;800000&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#800000')" style="cursor:pointer" color='#800000'><b>&nbsp; Maroon&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#66CDAA')" style="cursor:pointer" color='#66CDAA'><b>&nbsp;66CDAA&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#66CDAA')" style="cursor:pointer" color='#66CDAA'><b>&nbsp; MediumAquaMarine&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#0000CD')" style="cursor:pointer" color='#0000CD'><b>&nbsp;0000CD&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#0000CD')" style="cursor:pointer" color='#0000CD'><b>&nbsp; MediumBlue&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#BA55D3')" style="cursor:pointer" color='#BA55D3'><b>&nbsp;BA55D3&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#BA55D3')" style="cursor:pointer" color='#BA55D3'><b>&nbsp; MediumOrchid&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#9370D8')" style="cursor:pointer" color='#9370D8'><b>&nbsp;9370D8&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#9370D8')" style="cursor:pointer" color='#9370D8'><b>&nbsp; MediumPurple&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#3CB371')" style="cursor:pointer" color='#3CB371'><b>&nbsp;3CB371&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#3CB371')" style="cursor:pointer" color='#3CB371'><b>&nbsp; MediumSeaGreen&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#7B68EE')" style="cursor:pointer" color='#7B68EE'><b>&nbsp;7B68EE&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#7B68EE')" style="cursor:pointer" color='#7B68EE'><b>&nbsp; MediumSlateBlue&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#00FA9A')" style="cursor:pointer" color='#00FA9A'><b>&nbsp;00FA9A&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#00FA9A')" style="cursor:pointer" color='#00FA9A'><b>&nbsp; MediumSpringGreen&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#48D1CC')" style="cursor:pointer" color='#48D1CC'><b>&nbsp;48D1CC&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#48D1CC')" style="cursor:pointer" color='#48D1CC'><b>&nbsp; MediumTurquoise&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#C71585')" style="cursor:pointer" color='#C71585'><b>&nbsp;C71585&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#C71585')" style="cursor:pointer" color='#C71585'><b>&nbsp; MediumVioletRed&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#191970')" style="cursor:pointer" color='#191970'><b>&nbsp;191970&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#191970')" style="cursor:pointer" color='#191970'><b>&nbsp; MidnightBlue&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#F5FFFA')" style="cursor:pointer" color='#F5FFFA'><b>&nbsp;F5FFFA&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#F5FFFA')" style="cursor:pointer" color='#F5FFFA'><b>&nbsp; MintCream&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FFE4E1')" style="cursor:pointer" color='#FFE4E1'><b>&nbsp;FFE4E1&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FFE4E1')" style="cursor:pointer" color='#FFE4E1'><b>&nbsp; MistyRose&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FFE4B5')" style="cursor:pointer" color='#FFE4B5'><b>&nbsp;FFE4B5&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FFE4B5')" style="cursor:pointer" color='#FFE4B5'><b>&nbsp; Moccasin&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FFDEAD')" style="cursor:pointer" color='#FFDEAD'><b>&nbsp;FFDEAD&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FFDEAD')" style="cursor:pointer" color='#FFDEAD'><b>&nbsp; NavajoWhite&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#000080')" style="cursor:pointer" color='#000080'><b>&nbsp;000080&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#000080')" style="cursor:pointer" color='#000080'><b>&nbsp; Navy&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FDF5E6')" style="cursor:pointer" color='#FDF5E6'><b>&nbsp;FDF5E6&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FDF5E6')" style="cursor:pointer" color='#FDF5E6'><b>&nbsp; OldLace&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#808000')" style="cursor:pointer" color='#808000'><b>&nbsp;808000&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#808000')" style="cursor:pointer" color='#808000'><b>&nbsp; Olive&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#6B8E23')" style="cursor:pointer" color='#6B8E23'><b>&nbsp;6B8E23&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#6B8E23')" style="cursor:pointer" color='#6B8E23'><b>&nbsp; OliveDrab&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FFA500')" style="cursor:pointer" color='#FFA500'><b>&nbsp;FFA500&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FFA500')" style="cursor:pointer" color='#FFA500'><b>&nbsp; Orange&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FF4500')" style="cursor:pointer" color='#FF4500'><b>&nbsp;FF4500&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FF4500')" style="cursor:pointer" color='#FF4500'><b>&nbsp; OrangeRed&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#DA70D6')" style="cursor:pointer" color='#DA70D6'><b>&nbsp;DA70D6&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#DA70D6')" style="cursor:pointer" color='#DA70D6'><b>&nbsp; Orchid&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#EEE8AA')" style="cursor:pointer" color='#EEE8AA'><b>&nbsp;EEE8AA&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#EEE8AA')" style="cursor:pointer" color='#EEE8AA'><b>&nbsp; PaleGoldenRod&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#98FB98')" style="cursor:pointer" color='#98FB98'><b>&nbsp;98FB98&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#98FB98')" style="cursor:pointer" color='#98FB98'><b>&nbsp; PaleGreen&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#AFEEEE')" style="cursor:pointer" color='#AFEEEE'><b>&nbsp;AFEEEE&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#AFEEEE')" style="cursor:pointer" color='#AFEEEE'><b>&nbsp; PaleTurquoise&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#D87093')" style="cursor:pointer" color='#D87093'><b>&nbsp;D87093&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#D87093')" style="cursor:pointer" color='#D87093'><b>&nbsp; PaleVioletRed&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FFEFD5')" style="cursor:pointer" color='#FFEFD5'><b>&nbsp;FFEFD5&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FFEFD5')" style="cursor:pointer" color='#FFEFD5'><b>&nbsp; PapayaWhip&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FFDAB9')" style="cursor:pointer" color='#FFDAB9'><b>&nbsp;FFDAB9&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FFDAB9')" style="cursor:pointer" color='#FFDAB9'><b>&nbsp; PeachPuff&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#CD853F')" style="cursor:pointer" color='#CD853F'><b>&nbsp;CD853F&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#CD853F')" style="cursor:pointer" color='#CD853F'><b>&nbsp; Peru&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FFC0CB')" style="cursor:pointer" color='#FFC0CB'><b>&nbsp;FFC0CB&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FFC0CB')" style="cursor:pointer" color='#FFC0CB'><b>&nbsp; Pink&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#DDA0DD')" style="cursor:pointer" color='#DDA0DD'><b>&nbsp;DDA0DD&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#DDA0DD')" style="cursor:pointer" color='#DDA0DD'><b>&nbsp; Plum&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#B0E0E6')" style="cursor:pointer" color='#B0E0E6'><b>&nbsp;B0E0E6&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#B0E0E6')" style="cursor:pointer" color='#B0E0E6'><b>&nbsp; PowderBlue&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#800080')" style="cursor:pointer" color='#800080'><b>&nbsp;800080&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#800080')" style="cursor:pointer" color='#800080'><b>&nbsp; Purple&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FF0000')" style="cursor:pointer" color='#FF0000'><b>&nbsp;FF0000&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FF0000')" style="cursor:pointer" color='#FF0000'><b>&nbsp; Red&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#BC8F8F')" style="cursor:pointer" color='#BC8F8F'><b>&nbsp;BC8F8F&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#BC8F8F')" style="cursor:pointer" color='#BC8F8F'><b>&nbsp; RosyBrown&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#4169E1')" style="cursor:pointer" color='#4169E1'><b>&nbsp;4169E1&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#4169E1')" style="cursor:pointer" color='#4169E1'><b>&nbsp; RoyalBlue&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#8B4513')" style="cursor:pointer" color='#8B4513'><b>&nbsp;8B4513&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#8B4513')" style="cursor:pointer" color='#8B4513'><b>&nbsp; SaddleBrown&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FA8072')" style="cursor:pointer" color='#FA8072'><b>&nbsp;FA8072&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FA8072')" style="cursor:pointer" color='#FA8072'><b>&nbsp; Salmon&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#F4A460')" style="cursor:pointer" color='#F4A460'><b>&nbsp;F4A460&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#F4A460')" style="cursor:pointer" color='#F4A460'><b>&nbsp; SandyBrown&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#2E8B57')" style="cursor:pointer" color='#2E8B57'><b>&nbsp;2E8B57&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#2E8B57')" style="cursor:pointer" color='#2E8B57'><b>&nbsp; SeaGreen&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FFF5EE')" style="cursor:pointer" color='#FFF5EE'><b>&nbsp;FFF5EE&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FFF5EE')" style="cursor:pointer" color='#FFF5EE'><b>&nbsp; SeaShell&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#A0522D')" style="cursor:pointer" color='#A0522D'><b>&nbsp;A0522D&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#A0522D')" style="cursor:pointer" color='#A0522D'><b>&nbsp; Sienna&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#C0C0C0')" style="cursor:pointer" color='#C0C0C0'><b>&nbsp;C0C0C0&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#C0C0C0')" style="cursor:pointer" color='#C0C0C0'><b>&nbsp; Silver&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#87CEEB')" style="cursor:pointer" color='#87CEEB'><b>&nbsp;87CEEB&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#87CEEB')" style="cursor:pointer" color='#87CEEB'><b>&nbsp; SkyBlue&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#6A5ACD')" style="cursor:pointer" color='#6A5ACD'><b>&nbsp;6A5ACD&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#6A5ACD')" style="cursor:pointer" color='#6A5ACD'><b>&nbsp; SlateBlue&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#708090')" style="cursor:pointer" color='#708090'><b>&nbsp;708090&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#708090')" style="cursor:pointer" color='#708090'><b>&nbsp; SlateGray&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FFFAFA')" style="cursor:pointer" color='#FFFAFA'><b>&nbsp;FFFAFA&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FFFAFA')" style="cursor:pointer" color='#FFFAFA'><b>&nbsp; Snow&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#00FF7F')" style="cursor:pointer" color='#00FF7F'><b>&nbsp;00FF7F&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#00FF7F')" style="cursor:pointer" color='#00FF7F'><b>&nbsp; SpringGreen&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#4682B4')" style="cursor:pointer" color='#4682B4'><b>&nbsp;4682B4&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#4682B4')" style="cursor:pointer" color='#4682B4'><b>&nbsp; SteelBlue&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#D2B48C')" style="cursor:pointer" color='#D2B48C'><b>&nbsp;D2B48C&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#D2B48C')" style="cursor:pointer" color='#D2B48C'><b>&nbsp; Tan&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#008080')" style="cursor:pointer" color='#008080'><b>&nbsp;008080&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#008080')" style="cursor:pointer" color='#008080'><b>&nbsp; Teal&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#D8BFD8')" style="cursor:pointer" color='#D8BFD8'><b>&nbsp;D8BFD8&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#D8BFD8')" style="cursor:pointer" color='#D8BFD8'><b>&nbsp; Thistle&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FF6347')" style="cursor:pointer" color='#FF6347'><b>&nbsp;FF6347&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FF6347')" style="cursor:pointer" color='#FF6347'><b>&nbsp; Tomato&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#40E0D0')" style="cursor:pointer" color='#40E0D0'><b>&nbsp;40E0D0&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#40E0D0')" style="cursor:pointer" color='#40E0D0'><b>&nbsp; Turquoise&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#EE82EE')" style="cursor:pointer" color='#EE82EE'><b>&nbsp;EE82EE&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#EE82EE')" style="cursor:pointer" color='#EE82EE'><b>&nbsp; Violet&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#F5DEB3')" style="cursor:pointer" color='#F5DEB3'><b>&nbsp;F5DEB3&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#F5DEB3')" style="cursor:pointer" color='#F5DEB3'><b>&nbsp; Wheat&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FFFFFF')" style="cursor:pointer" color='#FFFFFF'><b>&nbsp;FFFFFF&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FFFFFF')" style="cursor:pointer" color='#FFFFFF'><b>&nbsp; White&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#F5F5F5')" style="cursor:pointer" color='#F5F5F5'><b>&nbsp;F5F5F5&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#F5F5F5')" style="cursor:pointer" color='#F5F5F5'><b>&nbsp; WhiteSmoke&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#FFFF00')" style="cursor:pointer" color='#FFFF00'><b>&nbsp;FFFF00&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#FFFF00')" style="cursor:pointer" color='#FFFF00'><b>&nbsp; Yellow&nbsp;</b></font>
        </td>
    </tr>
    <tr>
        <td>
            <font @click="sendFont('#9ACD32')" style="cursor:pointer" color='#9ACD32'><b>&nbsp;9ACD32&nbsp;</b></font>
        </td>
        <td>
            <font @click="sendFont('#9ACD32')" style="cursor:pointer" color='#9ACD32'><b>&nbsp; YellowGreen&nbsp;</b></font>
        </td>
    </tr>
    </tbody>
  </v-simple-table>
</div>
</template>

<script>
export default {
  props: {
    sendFont: Function
  }
}
</script>

<style>
</style>
